import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityReport } from "../../entity/EntityReport";

export class DtoReportsGetRes extends EntityReport {
  public items: EntityReport[]  = [];
}
